import React from "react";
import Select, { components } from "react-select";
const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused} >
        {props.selectProps.placeholder}
      </Placeholder>

      {/* این div جدید فقط برای تگ‌هاست تا اسکرول بخورد و لیبل را مخفی نکند */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexWrap: 'wrap',
        maxHeight: '80px', // ارتفاع دلخواه برای اسکرول
        overflowY: 'auto',
        alignItems: 'center',
        gap: '4px'
      }}>
        {React.Children.map(children, (child) =>
          child && child.type !== Placeholder ? child : null
        )}
      </div>
    </ValueContainer>
  );
};

const SelectComponent = (props) => {
  const customStyles = {
    menu: (base) => ({
      ...base, zIndex: 9999,
    }),
    control: (base, state) => ({
      ...base,
      border: props.noBorder ? 0 : base.border, // حذف بوردر
      boxShadow: props.noBorder ? 0 : base.boxShadow, // حذف سایه آبی (مهم‌ترین بخش)
      '&:hover': {
        border: props.noBorder ? 0 : base.border, // حذف بوردر در حالت hover
      },
      '& .select__placeholder': {
        opacity: state.isFocused ? props.noLabel ? 0.5 : 1 : 1, // اگر فوکوس شد ۰.۵، وگرنه ۱
        transition: 'opacity 0.2s ease',
      }
    }),
    container: (provided, state) => ({
      ...provided,
    }),
    menuList: () => ({
      maxHeight: 200,
      overflow: "auto"
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      overflow: "visible",
      padding: '2px 8px 2px 0',
    }),
    singleValue: (provided, state) => ({
      ...provided,
      paddingTop: state.data.extraPadding && 5,
    }),
    placeholder: (provided, state) => ({
      ...provided,
      position: "absolute",
      top: state.hasValue || state.selectProps.inputValue ? "-13px" : "15%",
      backgroundColor: state.hasValue || state.selectProps.inputValue ? "white" : "transparent",
      transition: "top 0.1s, font-size 0.1s",
      fontSize: (state.hasValue || state.selectProps.inputValue) && 11,
      paddingRight: state.hasValue || state.selectProps.inputValue ? "4px" : "0px",
      paddingLeft: state.hasValue || state.selectProps.inputValue ? "4px" : "0px",
      display: state.hasValue || !!state.selectProps.inputValue ? props.noLabel ? "none" : "block" : "block",
      fontWeight: props.boldPlaceholder ? "800" : provided.fontWeight,
      color: props.color ?? "#808080",
    })
    ,
    option: (style, { isSelected, data }) => ({ ...style, display: isSelected ? "none" : "block", color: data?.color }),
    dropdownIndicator: (style) => ({ ...style, padding: "4px" }),
  };


  const formatOptionLabel = (option, { context }) => {
    if (!option.rawHtml || context === "value") return option.label

    // در لیست بازشو، HTML کامل را نمایش بده
    return <div dangerouslySetInnerHTML={{ __html: option.rawHtml }} />;

  };

  return (
    <Select
      menuPortalTarget={props.noLabel ? document.body : undefined}
      classNamePrefix="select"
      components={{
        ValueContainer: CustomValueContainer,
      }}
      onKeyDown={(e) => {
        if (!props.noClear) {
          if (e.key === "Escape") {
            e.target.value = null;
            if (!!props.onChange)
              props?.onChange([])
            else
              props?.field?.onChange([])
            e.stopPropagation()
            e.preventDefault()
          }
        }
      }}
      styles={customStyles}
      value={props?.value || props?.field?.value || ""}
      onChange={props?.onChange || props?.field?.onChange}
      closeMenuOnSelect={!props.isMulti}
      blurInputOnSelect={!props.isMulti}
      isClearable={!props.noClear}
      formatOptionLabel={formatOptionLabel}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          text: props.color ?? theme.colors.text,        // رنگ فونت اصلی
          primary: props.color ?? theme.colors.primary,     // رنگ اصلی (برای فوکوس و انتخاب)
        },
      })}
      {...props}
    />
  );
};

export default SelectComponent;
